export { TinyMceModule } from './src/tinymce.module';
export { TinymceComponent } from './src/components/tinymce.component';
